import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import WebinarSessionLinkInterface from 'common/types/entities/WebinarSessionLinkInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createWebinarSessionLink(
  parentId: string,
  masterBlockId?: MasterBlockId,
): WebinarSessionLinkInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.WebinarSessionLink,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.WebinarSessionLink,
    color: 'rgba(0, 0, 238, 1)',
    fontSize: 30,
  }
}
